import React from 'react';
import { useLocation } from 'react-router-dom';
import { useViewerStore } from '../../../../store/store';
import { getMenubarPathFromPathname } from './getMenubarPath';

const MenubarPathBar: React.FC = () => {
    const storePathname = useViewerStore((state) => state.pathname);
    const isDashboardOpen = useViewerStore((state) => state.isDashboardOpen);
    const { pathname: routePathname } = useLocation();
    const pathname = storePathname || routePathname;
    const path = getMenubarPathFromPathname(pathname);

    if (!path || isDashboardOpen) {
        return null;
    }

    return (
        <div
            id="editorMenubarPath"
            className="editor-menubar-path"
            role="navigation"
            aria-label="Current menubar location"
        >
            <span className="editor-menubar-path__section">{path.section}</span>
            <span className="editor-menubar-path__separator" aria-hidden="true">
                /
            </span>
            <span className="editor-menubar-path__page">{path.page}</span>
        </div>
    );
};

export default MenubarPathBar;
